import { useState } from "react";
import Photos from "./Photos";
import Videos from "./Videos";
import Publication from "./Publication";
import { useSelector } from "react-redux";

const PhotoVideoPublication = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const [activeTab, setActiveTab] = useState("photos");

  return (
    <>
      <div className="photo-gallery-area ">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
              <ul className="nav nav-pills">
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "photos" ? "active" : ""
                    }`}
                    data-bs-toggle="pill"
                    href="#photos"
                    onClick={() => setActiveTab("photos")}
                  >
                    {languageType === "hi" ? "फोटो" : "Photos"}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "videos" ? "active" : ""
                    }`}
                    data-bs-toggle="pill"
                    href="#videos"
                    onClick={() => setActiveTab("videos")}
                  >
                    {languageType === "hi" ? "वीडियो" : "Videos"}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "publications" ? "active" : ""
                    }`}
                    data-bs-toggle="pill"
                    href="#publications"
                    onClick={() => setActiveTab("publications")}
                  >
                    {languageType === "hi" ? "प्रकाशन" : "Publications"}
                  </a>
                </li>
              </ul>
              <div className="tab-content" style={{ position: "relative" }}>
                {activeTab === "photos" && <Photos />}
                {activeTab === "videos" && <Videos />}
                {activeTab === "publications" && <Publication />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhotoVideoPublication;
